import React, { useState } from 'react';
import { toast } from 'react-toastify';
import AppModal from '../../common/AppModal';
import { FiColumns } from 'react-icons/fi';

const AddBoard = ({ onHide, show, handleAddColumn }) => {
    const [boardInput, setBoardInput] = useState('');

    const handleSave = () => {
        if (!boardInput.trim()) {
            toast.warning('Please Enter Column Name');
            return;
        }
        handleAddColumn(boardInput);
        onHide();
    };

    const handleClose = () => {
        setBoardInput('');
        onHide();
    };

    return (
        <AppModal
            show={show}
            onClose={handleClose}
            icon={<FiColumns size={18} color="#fff" />}
            title="Add Column"
            subtitle="Enter a name for the new board column"
            maxWidth="440px"
            footer={
                <>
                    <button
                        onClick={handleClose}
                        style={{
                            padding: '8px 20px',
                            borderRadius: '8px',
                            border: '1px solid #d1d5db',
                            background: '#fff',
                            color: '#374151',
                            fontSize: '14px',
                            fontWeight: '500',
                            cursor: 'pointer',
                        }}
                        onMouseEnter={e => { e.currentTarget.style.background = '#f3f4f6'; }}
                        onMouseLeave={e => { e.currentTarget.style.background = '#fff'; }}
                    >
                        Close
                    </button>
                    <button
                        onClick={handleSave}
                        style={{
                            padding: '8px 24px',
                            borderRadius: '8px',
                            border: 'none',
                            background: 'linear-gradient(135deg, #1a7d3e 0%, #34a85a 100%)',
                            color: '#fff',
                            fontSize: '14px',
                            fontWeight: '600',
                            cursor: 'pointer',
                            boxShadow: '0 2px 8px rgba(26,125,62,0.25)',
                        }}
                        onMouseEnter={e => { e.currentTarget.style.background = '#145f30'; }}
                        onMouseLeave={e => { e.currentTarget.style.background = 'linear-gradient(135deg, #1a7d3e 0%, #34a85a 100%)'; }}
                    >
                        Save
                    </button>
                </>
            }
        >
            <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                <label style={{ fontSize: '13px', fontWeight: '600', color: '#374151' }}>
                    Column Name
                </label>
                <input
                    type="text"
                    placeholder="e.g. In Review"
                    value={boardInput}
                    autoFocus
                    onChange={(e) => setBoardInput(e.target.value.trimStart())}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            e.preventDefault();
                            handleSave();
                        }
                    }}
                    style={{
                        width: '100%',
                        padding: '10px 14px',
                        borderRadius: '8px',
                        border: '1.5px solid #d1d5db',
                        fontSize: '14px',
                        color: '#111827',
                        outline: 'none',
                        background: '#fff',
                        boxSizing: 'border-box',
                        transition: 'border-color 0.15s',
                    }}
                    onFocus={e => { e.currentTarget.style.borderColor = '#1a7d3e'; e.currentTarget.style.boxShadow = '0 0 0 3px rgba(26,125,62,0.10)'; }}
                    onBlur={e => { e.currentTarget.style.borderColor = '#d1d5db'; e.currentTarget.style.boxShadow = 'none'; }}
                />
            </div>
        </AppModal>
    );
};

export default AddBoard;
